/*
 * Copyright (c) 2020. American Express Company
 */

import _ from 'lodash';
import { MatchModel, PlanType } from 'src/types/match.model';
import BWDataService from './bw-data.service';

export default class MatchService extends BWDataService {
    public static async create(): Promise<MatchModel> {
        return await super.get('/match/new');
    }

    // @ts-ignore
    public static async get(): Promise<MatchModel | null> {
        return await super.get('/match');
    }

    public static async upsert(match: MatchModel): Promise<MatchModel> {
        let preTaxSalary = _.get(match, 'preTaxSalary');
        if (preTaxSalary) preTaxSalary = Math.round(preTaxSalary);

        const payload: MatchModel = {
            incomeUid: match.incomeUid,
            preTaxSalary,
            planType: String(_.get(match, 'planType')) as PlanType,
            matchType: _.get(match, 'matchType')
        };
        return await this.post('/match', payload);
    }

    public static async deleteMatch(match: MatchModel): Promise<number> {
        return await this.delete(`/match/${match.id}`);
    }
}
